export const white = '#FFFFFF';
export const black = '#000000';
